import {Component, Input} from '@angular/core';
import {SitePage} from "../../pages/site/site";
import {NavController} from "ionic-angular";
import {Site} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";

@Component({
  selector: 'site-preview',
  templateUrl: 'site-preview.html'
})
export class SitePreviewComponent {

  @Input('siteId') siteId: number;

  constructor(public navCtrl: NavController, private data: DataProvider) {
  }

  protected getPhoto(photo: string) { return DataProvider.getPhotoUrl(photo, true); }

  protected getNumberRoutes(): number { return DataProvider.getSiteNumberRoutes(this.getSite()); }

  protected getNumberSectors(): number { return this.getSite().sectors.length; }

  protected openSite(): void {
    this.navCtrl.push(SitePage, this.getSite().id).catch();
  }

  protected getSite(): Site { return this.data.getSite(this.siteId); }

}



// WEBPACK FOOTER //
// ./src/components/site-preview/site-preview.ts